










import { Component, Mixins } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import AppApiMixin from "@/components/mixins/AppApi.vue";
import EquipmentListCard from "@/components/for-counters-values/EquipmentListCard.vue";
import {AccountingPointIndications} from "@/models/accounting-point";

@Component({
  components: {
    EquipmentListCard,
  },
  computed: {
    ...mapState({
      accountingPointsPU: "accountingPoints",
    }),
    ...mapGetters({
      contractId: "contract/id",
    }),
    accountingPoints() {
      if (this.accountingPointsPU.accountingPointsPU != undefined) {
        const accountingPointsPU = this.accountingPointsPU.accountingPointsPU.map((item) => {
          return item as AccountingPointIndications;
        });
        return [...new Map(accountingPointsPU.filter(item => item.субабонент == 0).map(item => [item.счетчикид, item])).values()];
      }
      return [];
    }
  },
})
class ValuesInput extends Mixins(AppApiMixin) {
  [x: string]: any;

  created() {
    this.fetchAccountingPointsPU(this.contractId);
    this.fetchAccountingPointsMeasures(this.contractId);
  }
}

export default ValuesInput;
